module.exports = __webpack_public_path__ + "media/49.057a7a2d.mp3";